export default __webpack_public_path__ + "static/media/g_wdt_c_0.01732757.mp3";